import { lazy, Suspense } from "react";
import { GlobalLoading } from "../Utils";

const Resources = lazy(() => import("../Components/ProfilesType/Admin/Resources/Resources"));
const BookingsDashboard = lazy(() => import("../Components/ProfilesType/Owner/Bookings/BookingsDashboard"));
const OwnerHome = lazy(() => import("../Components/ProfilesType/Owner/OwnerHome/OwnerHome"));
const MentorDashboard = lazy(() => import("../Components/ProfilesType/Owner/Mentors/MentorsDashboard"));
const MenteeDashboard = lazy(() => import("../Components/ProfilesType/Owner/Mentees/MenteesDashboard"));
const BookingsData = lazy(() => import("../Components/ProfilesType/Owner/Bookings/BookingsData"));
const MenteesData = lazy(() => import("../Components/ProfilesType/Owner/Mentees/MenteesData"));
const MentorsData = lazy(() => import("../Components/ProfilesType/Owner/Mentors/MentorsData"));

export const ownerRoutes = [
    {
        index: true,
        element: <Suspense fallback={<GlobalLoading />}><OwnerHome /></Suspense>,
    },
    {
        path: "resource",
        element: <Suspense fallback={<GlobalLoading />}><Resources /></Suspense>,
    },
    {
        path: "mentors",
        element: <Suspense fallback={<GlobalLoading />}><MentorDashboard /></Suspense>,
    },
    {
        path: "mentees",
        element: <Suspense fallback={<GlobalLoading />}><MenteeDashboard /></Suspense>,
    },
    {
        path: "bookings",
        element: <Suspense fallback={<GlobalLoading />}><BookingsDashboard /></Suspense>
    },
    {
        path: "bookings-data",
        element: <Suspense fallback={<GlobalLoading />}><BookingsData /></Suspense>
    },
    {
        path: "mentor-data",
        element: <Suspense fallback={<GlobalLoading />}><MentorsData /></Suspense>
    },
    {
        path: "mentees-data",
        element: <Suspense fallback={<GlobalLoading />}><MenteesData /></Suspense>
    },
]